module.exports = __webpack_public_path__ + "static/img/top-bg.7838fd3a.png";